import { HTMLProps, forwardRef } from 'react'
import { cn } from '@/lib/utils'

export type SurfaceProps = HTMLProps<HTMLDivElement> & {
  withShadow?: boolean
  withBorder?: boolean
}

export const Surface = forwardRef<HTMLDivElement, SurfaceProps>(
  (
    { children, className, withShadow = true, withBorder = true, ...props },
    ref
  ) => {
    const surfaceClass = cn(
      className,
      'bg-popover rounded-md popover-shadow',
      withBorder ? '' : ''
    )

    return (
      <div
        className={surfaceClass}
        style={
          withShadow
            ? {
                // boxShadow:
                //   'rgba(0, 0, 0, 0.1) 0px 14px 28px -6px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px, rgba(84, 72, 49, 0.08) 0px 0px 0px 1px',
              }
            : {}
        }
        {...props}
        ref={ref}
      >
        {children}
      </div>
    )
  }
)

Surface.displayName = 'Surface'
